import { useEffect } from 'react';
import { loadGA } from '../utils/analytics';

const GoogleAnalytics = () => {
	useEffect(() => {
		// Load Google Analytics when component mounts
		loadGA();
	}, []);

	// This component doesn't render anything
	return null;
};

export default GoogleAnalytics;
